import React from "react";
import { NavLink } from "react-router-dom";
import classes from "./ChapterSwitchButtons.module.css";

interface ChapterSwitchButtonsInterface {
    slug?: string;
    db: any;
    baselink: string;
    max?: number;
}

const ChapterSwitchButtons = ({ slug, db, baselink, max }: ChapterSwitchButtonsInterface) => {
    const index = db.findIndex((object: any) => {
        return object.slug === slug;
    });

    /* I think that 6 can be removed, I'm letting it stay here if anything breaks */
    const maximumNumber = max ? max : 6;

    const nextChapter = index < maximumNumber ? index + 1 : index;
    const previousChapter = index > 0 ? index - 1 : index;

    if (
        slug === "vokabular" ||
        slug === "Prehled-tvaru-ruky-ceskeho-znakoveho-jazyka" ||
        slug === "Seznam-zkratek-uziti-symbolu-a-poznamek-k-zapisu-znaku" ||
        slug === "Seznam-obrazku-a-tabulek" ||
        slug === "Seznam-pouzite-literatury" ||
        slug === "Seznam-doporucene-literatury-dle-temat"
    )
        return <></>;

    return (
        <div className={classes.buttonWrapper}>

            <NavLink
                to={`/${baselink}/${db[previousChapter].slug}`}
                style={{ textDecoration: "none", color: 'black', backgroundColor: "initial", flex: "50%" }}
            >
                <button
                    className={index === 0 ? classes.buttonDisabled : classes.button}
                    onClick={() => window.scrollTo(0, 0)}
                    disabled={index === 0 ? true : false}
                >
                    Předchozí kapitola
                </button>
            </NavLink>


            <NavLink
                to={`/${baselink}/${db[nextChapter].slug}`}
                style={{ textDecoration: "none", color: 'black', backgroundColor: "initial", flex: "50%" }}
            >
                <button
                    className={index === maximumNumber ? classes.buttonDisabled : classes.button}
                    onClick={() => window.scrollTo(0, 0)}
                    disabled={index === maximumNumber ? true : false}
                >
                    Následující kapitola
                </button>
            </NavLink>
        </div>
    );
}

export default ChapterSwitchButtons;